import { AudioLevelAnalyser } from '../../helpers/analysers/audio-level-analyser';
import { getAudioContext } from '../../helpers/audio-context';
import { DeviceManager } from '../device-manager/device-manager';
import { BroadcastManager } from './broadcast-manager';
import { GoloomSDK } from './goloom-sdk';

export const goloomSdk = new GoloomSDK();

export const deviceManager = new DeviceManager(goloomSdk);
export const broadcastManager = new BroadcastManager();

const audioContext = getAudioContext();
export const audioLevelAnalyser = audioContext ? new AudioLevelAnalyser(audioContext) : null;

export * from './helpers';
export * from './constants';
export * from './types';
